<template>
  <div :class="$style.wrapper">
    <button
      :class="$style.btnAccordion"
      @click="isOpened = !isOpened"
    >
      <div :class="$style.header">
        <span :class="$style.headerText">{{ $t('common.additionalFilters') }}</span>
        <span :class="$style.headerChoose">{{ $t('common.choose') }}</span>
      </div>
      <span :class="{ [$style.caretClosed]: !isOpened }">
        <img src="@/assets/images/icons/computer/screenshots/additional-angle.svg">
      </span>
    </button>
    <div
      v-if="isOpened"
      :class="$style.content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      isOpened: false,
    }),
  };
</script>

<style lang="scss" module>
  .wrapper {
    bottom: 0;
    border: 1px solid $borderColor;
    background: $white;
    position: relative;
    width: 270px;
    flex-shrink: 0;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .headerText {
    color: #7e7e7e;
    font-weight: 300;
    font-size: 12px;
    line-height: 27px;
  }
  .headerChoose {
    font-size: 14px;
    line-height: 27px;
  }
  .content {
    position: absolute;
    z-index: 10000;
  }

  .btnAccordion {
    cursor: pointer;
    font-size: 13px;
    user-select: none;
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 16px;
    background-color: $white;
  }

  .caretClosed {
    transform: rotate(180deg);
  }
</style>
